import React, { useState, useEffect } from "react";
import { Configurations } from "../../../Utils/Configurations";
import axios from "axios";
import { withRouter } from 'react-router-dom';
import VideoHighLightCard from "../../../Components/Video-Highlight-Card/Video-HighLight-Card.js";

const VideosHighlightsList = ({ history }) => {

    const [destaques, setDestaques] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        chamadaDestaques()
    }, [])

    const chamadaDestaques = () => {
        const config = new Configurations();
        axios.get(config.apiBasePath + `/destaques-videos-podcasts?plataforma=Hub&tipo=video`)
            .then(response => {
                setDestaques(response.data.data)
            })
            .catch(error => {
                console.log("ERROR: ", error)
            })
            .finally(() => {
                setLoading(false)
            });
    }

// (No replacement lines; the block is removed entirely)
    // }

    useEffect(() => {
        if (destaques) {
            setLoading(false);
        }
    }, [destaques])


    const novoDestaque = () => {
        history.push({
            pathname: `videos/novo`,
        });
    }




    return (
        <div className="cile-remessas">
            <div className="row">
                <div className="col-12 py-2">
                    <div className="row no-gutters align-items-center">
                        <div className="col-12 col-lg-4 text-center text-lg-left">
                            <h2 className="title-1 d-none d-lg-block">Vídeos - Destaques</h2>
                        </div>
                        <div className="col-6 col-lg-4 text-center text-lg-center">
                                <button className="btn btn-outline-primary cursor-pointer" type="button" onClick={() => novoDestaque()}>
                                    incluir destaque
                                </button>
                        </div>
                        <div className="col-6 col-lg-4 text-center text-lg-right">
                            <div className="row no-gutters">
                                <div className="col py-2 py-lg-0">
                                    <button onClick={() => window.history.go(-1)} className="btn btn-outline-secondary">voltar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card">
                <div className="row no-gutters align-items-center py-lg-4 px-lg-3">


                    {loading ?
                        <div className="d-flex justify-content-center w-100">
                            <div className="spinner-border text-primary" role="status" />
                        </div>
                        :
                        <div className="col-lg-10 col-12 offset-lg-1 offset-0">
                            {destaques && destaques.map((item, indice) => {
                                return (
                                    <VideoHighLightCard
                                        conteudo={item}
                                        setDestaques={setDestaques}
                                        setLoading={setLoading}
                                        key={item._id}
                                        indice={indice}
                                        size={destaques.length}
                                        chamadaDestaques={chamadaDestaques}
                                    />
                                )
                            })}
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}


export default withRouter(VideosHighlightsList);